import React from 'react';
import { motion } from 'framer-motion';
import DemographicsSummary from '../components/DemographicsSummary';
import TopBrandsSection from '../sections/TopBrandsSection';
import TopCreatorsSection from '../sections/TopCreatorsSection';
import TopPostsSection from '../sections/TopPostsSection';
import HottestPostsSection from '../sections/HottestPostsSection';
import BreakoutPostsSection from '../sections/BreakoutPostsSection';
import { Brand, Creator, Post, VideoData, VideoRefs } from '../types/socialGlass';

interface SummaryViewProps {
  topBrands: Brand[];
  topCreators: Creator[];
  posts: Post[];
  breakoutPosts: Post[];
  selectedCategory: string | null;
  selectedBrand: Brand | null;
  selectedCreator: Creator | null;
  showAllBrands: boolean;
  showAllCreators: boolean;
  idToData: Record<string, VideoData>;
  videoRefs: React.MutableRefObject<VideoRefs>;
  handleManualMute: () => void;
  handleManualUnmute: () => void;
  onBrandSelect: (brand: Brand) => void;
  onCreatorSelect: (creator: Creator) => void;
  onCategorySelect: (category: string) => void;
  onToggleShowAllBrands: () => void;
  onToggleShowAllCreators: () => void;
  isBrandSelected: (brand: Brand) => boolean;
  isCreatorSelected: (creator: Creator) => boolean;
  summaryData: any; // TODO: Type this properly
}

const SummaryView: React.FC<SummaryViewProps> = ({
  topBrands,
  topCreators,
  posts,
  breakoutPosts,
  selectedCategory,
  selectedBrand,
  selectedCreator,
  showAllBrands,
  showAllCreators,
  idToData,
  videoRefs,
  handleManualMute,
  handleManualUnmute,
  onBrandSelect,
  onCreatorSelect,
  onCategorySelect,
  onToggleShowAllBrands,
  onToggleShowAllCreators,
  isBrandSelected,
  isCreatorSelected,
  summaryData,
}) => {
  return (
    <>
      <DemographicsSummary />
      <motion.div
        key="summary"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        transition={{ duration: 0.4 }}
        className="flex flex-col gap-8 p-6"
        style={{ fontFamily: "Acumin Variable Concept, sans-serif" }}
      >
        {/* Top Brands */}
        <TopBrandsSection
          brands={topBrands}
          selectedBrand={selectedBrand}
          onBrandSelect={onBrandSelect}
          showAllBrands={showAllBrands}
          onToggleShowAll={onToggleShowAllBrands}
          isBrandSelected={isBrandSelected}
        />

        {/* Top Creators */}
        <TopCreatorsSection
          creators={topCreators}
          selectedCreator={selectedCreator}
          onCreatorSelect={onCreatorSelect}
          showAllCreators={showAllCreators}
          onToggleShowAll={onToggleShowAllCreators}
          isCreatorSelected={isCreatorSelected}
        />

        {/* Top Posts */}
        <TopPostsSection
          summaryData={summaryData}
          selectedCategory={selectedCategory}
          onCategorySelect={onCategorySelect}
        />

        {/* Hottest Posts */}
        <HottestPostsSection
          posts={posts}
          idToData={idToData}
          videoRefs={videoRefs}
          handleManualMute={handleManualMute}
          handleManualUnmute={handleManualUnmute}
        />

        {/* Breakout Content / High Signal Posts */}
        <BreakoutPostsSection
          posts={breakoutPosts}
          idToData={idToData}
          videoRefs={videoRefs}
          handleManualMute={handleManualMute}
          handleManualUnmute={handleManualUnmute}
        />
      </motion.div>
    </>
  );
};

export default SummaryView;
